import React from "react";
import { Link, useLocation } from "react-router-dom";
import styles from "./devHeader.module.css";

export default function DevHeader() {
  const location = useLocation();
  const currentPath = location.pathname;

  return (
    <header className={styles.header}>
      <div className={styles.container}>
        <Link to="/admin" className={styles.logo}>
          ADMIN PANEL
        </Link>
        <nav className={styles.nav}>
          {/* <Link to="/admin/book-list">Books</Link> */}
          <Link
            to="/admin/author-list"
            className={`${styles.link} ${currentPath === "/admin/author-list" ? styles.active : ""}`}
          >
            사용자
          </Link>
          <Link
            to="/admin/proposals"
            className={`${styles.link} ${currentPath === "/admin/proposals" ? styles.active : ""}`}
          >
            문의내역
          </Link>
          {/* <Link to="/admin/users">Users</Link> */}
          <Link
            to="/admin/settings"
            className={`${styles.link} ${currentPath === "/admin/settings" ? styles.active : ""}`}
          >
            견적서 양식
          </Link>
          <Link
            to="/admin/carousel-books"
            className={`${styles.link} ${currentPath === "/admin/carousel-books" ? styles.active : ""}`}
          >
            메인페이지 도서이미지
          </Link>
          {/* <Link to="/admin/permissions">Permissions</Link> */}
        </nav>
        <a href="/" className={styles.exitLink}>
          Exit to Main Site
        </a>
      </div>
    </header>
  );
}
